// extracted by mini-css-extract-plugin
export default {"container":"workTgFilter_container__couSF","label":"workTgFilter_label__xe+TY","selector":"workTgFilter_selector__aZSFk"};